export default __webpack_public_path__ + "static/media/comfortaa-regular-webfont.05df738f.woff2";